import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const addPhoneNumberMask = number => {
  if (number && typeof number === 'string') {
    if (number.startsWith('(')) {
      return number;
    }
    let splittedNumber = number.split(' ');
    if (splittedNumber.length === 2) {
      if (splittedNumber[0].includes('-')) {
        const numb = splittedNumber[0].split('-');
        const adds = splittedNumber[1];
        return `(${numb[0]}) ${numb[1]}-${numb[2]} ${adds}`;
      }
      return `(${splittedNumber[0]}) ${splittedNumber[1].slice(0, 3)}-${splittedNumber[1].slice(
        3,
        splittedNumber[1].length,
      )}`;
    }
    if (splittedNumber.length === 3) {
      return `(${splittedNumber[0]}) ${splittedNumber[1]}-${splittedNumber[2]}`;
    }
    splittedNumber = number.split('-');
    if (splittedNumber.length === 3) {
      return `(${splittedNumber[0]}) ${splittedNumber[1]}-${splittedNumber[2]}`;
    }
    if (splittedNumber.length === 1) {
      return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(
        6,
        10
      )}`;
    }
    return number;
  }
  return '';
};

const ContactDetailTab = ({ unit, showBudgetInformation, openWorksheetPDF, fetchTaxingUnit }) => {
  const [ contactData, setContactData ] = useState({});

  const getData = async () => {
    const res = await fetchTaxingUnit({
      id: unit.taxingUnitID,
    });
    if (res && res.results) {
      setContactData(res.results[0]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const openLink = (link) => {
    let to = link;
    if (link && !link.toLowerCase().includes('http://') && !link.toLowerCase().includes('https://')) {
      to = `https://${link}`;
    }
    window.open(to, '_blank');
  };
  return (
    <div>

      <div className='unit-info-container'>
        <div>
          <span className='title'>Taxing Unit Contact Info</span>
          <div>
            <span className='sub-title'>Taxing Unit Name:{' '}</span>
            <span>
              {contactData.taxingUnitName}
            </span>
          </div>
          <div>
            <span className='sub-title'>Website:&nbsp;</span>
            <a
              onClick={() => {
                openLink(contactData.url);
              }}
            >
              <span style={{ whiteSpace: 'nowrap' }}>{contactData.url}</span>
            </a>
          </div>
          {
            contactData.urlSecondary &&
              <div>
                <span className='sub-title' />
                <a
                  onClick={() => {
                    openLink(contactData.urlSecondary);
                  }}
                >
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {contactData.urlSecondary}
                  </span>
                </a>
              </div>
          }
          <div>
            <span className='sub-title'>Phone Number:{' '}</span>
            <span>
              {addPhoneNumberMask(
                contactData.phone
              )}
            </span>
          </div>
          <div>
            <span className='sub-title'>Email:{' '}</span>
            <span>{contactData.email}</span>
          </div>
        </div>
        <div>
          <span className='title'>Tax Assessor Collector</span>
          <div>
            <span className='sub-title'>Assessor Collector:{' '}</span>
            <span>
              {contactData.taxingUnitCollector}
            </span>
          </div>
          <div>
            <span className='sub-title'>Website:&nbsp;</span>
            <a
              onClick={() => {
                openLink(contactData.taxingUnitCollectorUrl);
              }}
            >
              <span style={{ whiteSpace: 'nowrap' }}>
                {contactData.taxingUnitCollectorUrl}
              </span>
            </a>
          </div>
          <div>
            <span className='sub-title'>Phone Number:{' '}</span>
            <span>
              {addPhoneNumberMask(contactData.taxingUnitCollectorPhone)}
            </span>
          </div>
          <div>
            <span className='sub-title'>Email:{' '}</span>
            <span>
              {contactData.taxingUnitCollectorEmail}
            </span>
          </div>
        </div>
        <div>
          {
            showBudgetInformation &&
            <>
              <span className='title'>Budget & Tax Rates</span>
              <div>
                <span className='sub-title'>Budget & Rate Information:{' '}</span>
                {contactData.budgetRateInformationS3ID ? (
                  <a onClick={() => openWorksheetPDF('budget', unit.taxingUnitID)}><span>Worksheet PDF</span></a>) :
                  <span>No Document</span>
                }
              </div>
            </>
          }
        </div>
      </div>
    </div>
  );
};

ContactDetailTab.propTypes = {
  fetchTaxingUnit: PropTypes.func.isRequired,
  openWorksheetPDF: PropTypes.func.isRequired,
  showBudgetInformation: PropTypes.any,
  unit: PropTypes.any,
};

export default ContactDetailTab;
